import React from "react";
import { motion } from "framer-motion";
import { Plus, FileUp, Youtube, FileText, Sparkles, Trophy, Rocket } from "lucide-react";

const FEATURES = [
  { icon: FileUp, label: "Upload PDFs" },
  { icon: Youtube, label: "Paste YouTube links" },
  { icon: FileText, label: "Import documentation" },
  { icon: Sparkles, label: "AI generates lessons, quizzes & projects" },
  { icon: Trophy, label: "AI creates Boss Battles & tracks progress" },
  { icon: Rocket, label: "Publish publicly & earn from it" },
];

/** The special, always-last marketplace card — CTA to jump down into the
 * AI Challenge Builder section (#ai-challenge-builder) below on the same page. */
export const CreateChallengeCard = () => {
  return (
    <motion.a
      href="#ai-challenge-builder" data-testid="create-your-own-challenge-card"
      initial={{ opacity: 0, y: 18 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.45 }}
      whileHover={{ y: -4 }}
      className="group relative rounded-2xl p-[1.5px] overflow-hidden"
      style={{ background: "linear-gradient(135deg, #5C9DFF, #B58BFF, #F59E0B, #5C9DFF)" }}
    >
      <div className="absolute inset-0 opacity-60 blur-xl group-hover:opacity-90 transition-opacity" style={{ background: "linear-gradient(135deg, #5C9DFF, #B58BFF, #F59E0B)" }} />
      <div className="relative rounded-2xl bg-[#0A101D] h-full p-5 flex flex-col">
        <div className="w-11 h-11 rounded-xl bg-white/[0.06] border border-white/15 flex items-center justify-center mb-3">
          <Plus className="w-5 h-5 text-white" strokeWidth={2} />
        </div>
        <h3 className="font-heading text-base font-semibold text-white leading-snug">+ Create Your Own Challenge</h3>
        <p className="text-xs text-slate-400 mt-1.5 leading-relaxed">Build a personalized 30-Day Challenge in minutes using AI.</p>
        <div className="flex flex-col gap-1.5 mt-4">
          {FEATURES.map((f) => {
            const Icon = f.icon;
            return (
              <span key={f.label} className="flex items-center gap-2 text-[11px] text-slate-300">
                <Icon className="w-3 h-3 text-[#5C9DFF] shrink-0" /> {f.label}
              </span>
            );
          })}
        </div>
        <span className="mt-4 flex items-center justify-center gap-2 text-sm font-semibold text-white bg-white/[0.08] group-hover:bg-white/[0.14] rounded-xl py-2.5 transition-colors">
          Create Challenge
        </span>
      </div>
    </motion.a>
  );
};
